import React from 'react';
import { Input } from 'rsuite';
import { FormField, FormGrid } from '../../common/FormModal';
import LanguageTabs, {
  getLanguagePanelId,
  getLanguageTabId,
  LanguageKey,
} from '../../common/LanguageTabs';

type Props = {
  slug: string;
  title: string;
  titleEn: string;
  titleDe: string;
  setSlug: (value: string) => void;
  setTitle: (value: string) => void;
  setTitleEn: (value: string) => void;
  setTitleDe: (value: string) => void;
};

export default function BlogCategoryModalContent({
  slug,
  title,
  titleEn,
  titleDe,
  setSlug,
  setTitle,
  setTitleEn,
  setTitleDe,
}: Props) {
  const [activeLanguage, setActiveLanguage] = React.useState<LanguageKey>('ua');
  const languageTabPrefix = 'blog-category-language';

  React.useEffect(() => {
    setActiveLanguage('ua');
  }, [slug]);

  const languageConfig: Record<
    LanguageKey,
    { value: string; setValue: (value: string) => void }
  > = {
    ua: { value: title, setValue: setTitle },
    en: { value: titleEn, setValue: setTitleEn },
    de: { value: titleDe, setValue: setTitleDe },
  };

  const activeLanguageConfig = languageConfig[activeLanguage];

  return (
    <>
      <FormGrid>
        <FormField label="Slug" required>
          <Input value={slug} onChange={setSlug} />
        </FormField>
      </FormGrid>
      <LanguageTabs
        activeLanguage={activeLanguage}
        onChange={setActiveLanguage}
        idPrefix={languageTabPrefix}
      />
      <div
        className="language-panel"
        role="tabpanel"
        id={getLanguagePanelId(languageTabPrefix, activeLanguage)}
        aria-labelledby={getLanguageTabId(languageTabPrefix, activeLanguage)}
      >
        <div className="language-fields">
          <FormField label="Назва" required={activeLanguage === 'ua'}>
            <Input
              value={activeLanguageConfig.value || ''}
              onChange={activeLanguageConfig.setValue}
            />
          </FormField>
        </div>
      </div>
    </>
  );
}
